import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import '../Styles/Hero.css';
import heroGif from '../assets/hero.png';

function Hero() {
    return (
        <section id="hero" className="hero-section">
            <Container>
                <Row className="align-items-center justify-content-center">
                    <Col lg={6} md={10} sm={12} className="mb-5 mb-lg-0">
                        <motion.div
                            initial={{ opacity: 0, y: 50 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8 }}
                        >
                            <motion.h1
                                className="hero-title"
                                initial={{ opacity: 0, x: -50 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ delay: 0.2, duration: 0.8 }}
                            >
                                Hello, I'm Manojdeep Dakavaram
                            </motion.h1>
                            <motion.h2
                                className="hero-subtitle"
                                initial={{ opacity: 0, x: -50 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ delay: 0.4, duration: 0.8 }}
                            >
                                Software Engineer | AI Agents | Cloud & Distributed Systems
                            </motion.h2>
                            <motion.p
                                className="hero-text"
                                initial={{ opacity: 0, x: -50 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ delay: 0.6, duration: 0.8 }}
                            >
                                I'm a Software Engineer who builds AI-powered systems, scalable cloud infrastructure, and production-grade backend services. I architected agent-based AI systems using LangGraph and RAG. With experience spanning GCP, AWS, and Azure, and 29 merged PRs in open-source, I turn complex engineering challenges into reliable, high-impact solutions.
                            </motion.p>
                            <motion.div
                                className="hero-skills"
                                initial={{ opacity: 0, y: 50 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.8, duration: 0.8 }}
                            >
                                {['Python', 'AI Agents', 'LangGraph', 'RAG', 'REST API', 'GCP', 'PostgreSQL', 'MongoDB'].map((skill, index) => (
                                    <motion.span
                                        key={skill}
                                        className="skill-tag"
                                        initial={{ opacity: 0, scale: 0.5 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{ delay: 1 + index * 0.1, duration: 0.5 }}
                                    >
                                        {skill}
                                    </motion.span>
                                ))}
                            </motion.div>
                            <motion.a
                                href="https://www.linkedin.com/in/manojdeep-dakavaram-12065117a/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="hero-button"
                                whileHover={{ scale: 1.05, backgroundColor: "#3a86ff" }}
                                whileTap={{ scale: 0.95 }}
                                initial={{ opacity: 0, y: 50 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 1.2, duration: 0.8 }}
                            >
                                Connect on LinkedIn
                            </motion.a>
                        </motion.div>
                    </Col>
                    <Col lg={6} md={10} sm={12}>
                        <motion.div
                            className="hero-image-container"
                            initial={{ opacity: 0, scale: 0.8 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 1 }}
                        >
                            <img src={heroGif} alt="Hero GIF" className="hero-image" />
                        </motion.div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Hero;